import EntitiesStep from "../Common/EntitiesStep/EntitiesStep";
import ErrorMessage from "../Common/ErrorMessage";
import InfoStepSkeleton from "../Common/InfoStep/components/InfoStepSkeleton";
import InfoStep from "../Common/InfoStep/InfoStep";
import ConnectStep from "./ConnectStep/ConnectStep";

type Props = {
	step: number;
	isError?: boolean;
	isLoading?: boolean;
};

// ----------------------------------------------------------------------

export const ConnectAccountContent = ({ step, isError, isLoading }: Props) => {
	if (isError) return <ErrorMessage />;
	if (isLoading) return <InfoStepSkeleton />;

	return (
		<>
			{step === 0 && (
				<InfoStep
					title='info_panel.connect_my_account_with'
					aboutData='info_panel.about_data_des'
				/>
			)}
			{step === 1 && <EntitiesStep />}
			{step === 2 && <ConnectStep />}
		</>
	);
};

export default ConnectAccountContent;
